import styled from 'styled-components';
import { colors, Cell, Button } from '@dexma/ui-components';

export const StyledOptionContainer = styled.div`
    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .error {
        color: ${colors.red};
        text-align: left;
    }
`;

export const StyledResetOptionContainer = styled(Cell)`
    display: flex;
    justify-content: end;
    margin-right: 0.5rem;
`;

export const StyledResetButton = styled(Button)`
    padding-right: 0rem;
`;
